import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import * as freeField from "./components/free-field";
import * as hardReflectingWall from "./components/hard-reflecting-wall";
import * as softAbsorbingWall from "./components/soft-absorbing-wall";
import * as soundScatteringWall from "./components/sound-scattering-wall";
import * as lowSoundBarrier from "./components/low-sound-barrier";
import * as highSoundBarrier from "./components/high-sound-barrier";

const principle: Slide = {
  description:
    "A simple simulation with a sound source and a listener above a non-reflecting floor. You can switch between different configurations of surfaces or barriers to see how the reflections and the reflectogram looks like, and listen to sound examples for these setups for a male voice and a some recorded drums.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controlsPosition: "top",
      extraContentLayout: "horizontal",
      controls: [
        {
          type: "dropdown",
          options: {},
          items: [
            { name: "Free field" },
            { name: "Hard reflecting wall" },
            { name: "Soft absorbing wall" },
            { name: "Sound scattering wall" },
            { name: "Low sound barrier" },
            { name: "High sound barrier" },
          ],
        },
      ],

      extraContent: [
        freeField.extraContent,
        hardReflectingWall.extraContent,
        softAbsorbingWall.extraContent,
        soundScatteringWall.extraContent,
        lowSoundBarrier.extraContent,
        highSoundBarrier.extraContent,
      ],
      components: [
        freeField.component,
        hardReflectingWall.component,
        softAbsorbingWall.component,
        soundScatteringWall.component,
        lowSoundBarrier.component,
        highSoundBarrier.component,
      ],
    },
  },
};

export default principle;
